import { render, staticRenderFns } from "./CartasTotales.vue?vue&type=template&id=5db0ab72&scoped=true&"
import script from "./CartasTotales.vue?vue&type=script&lang=js&"
export * from "./CartasTotales.vue?vue&type=script&lang=js&"
import style0 from "./CartasTotales.vue?vue&type=style&index=0&id=5db0ab72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0ab72",
  null
  
)

export default component.exports